import { cn } from '@/utils/cn';
import React from 'react';
import ImageComponentV2 from '../Image/ImageComponentV2';

function SpinningWheelImage({ className }) {
  return (
    <div
      className={cn(
        'spinning-the-wheel-image mx-auto overflow-hidden',
        className,
      )}
    >
      <ImageComponentV2
        src="/images/spinning-the-wheel.gif"
        className="w-[24px] h-[24px]"
        width={250}
        height={250}
        alt="spinning the wheel image"
        loading="lazy"
        unoptimized={false}
      />
    </div>
  );
}

export default SpinningWheelImage;
